import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="mt-12 bg-[#0e4a61] text-white">
            <div className="max-w-screen-xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
                {/* Column 1 */}
                <div>
                    <h4 className="text-lg font-semibold mb-3">Effortless English</h4>
                    <p className="text-sm text-blue-100 mb-4">Phương pháp học tiếng Anh hiệu quả và tự nhiên nhất</p>
                    <p className="text-sm font-semibold mb-2">Ứng dụng trên điện thoại</p>
                    <div className="flex flex-col gap-3">
                        <a className="inline-flex items-center gap-3 bg-white text-gray-800 rounded-md px-3 py-2 w-40 shadow-sm" href="#">
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 4h18v16H3z" fill="#fff"/></svg>
                            <span className="text-sm">Play store</span>
                        </a>
                        <a className="inline-flex items-center gap-3 bg-white text-gray-800 rounded-md px-3 py-2 w-40 shadow-sm" href="#">
                            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" fill="#000"/></svg>
                            <span className="text-sm">Apple store</span>
                        </a>
                    </div>
                </div>

                {/* Column 2 */}
                <div>
                    <h4 className="text-lg font-semibold mb-4">Khóa học</h4>
                    <ul className="space-y-2 text-sm text-blue-100">
                        <li><Link to="/course/pimsleur" className="hover:underline">Original Effortless English</Link></li>
                        <li><Link to="/course/flow" className="hover:underline">Flow English Lessons</Link></li>
                        <li><Link to="/course/power" className="hover:underline">Power English Now</Link></li>
                        <li><Link to="/course/succeed" className="hover:underline">Succeed English Business Course</Link></li>
                        <li><Link to="/course/business" className="hover:underline">Business English Conversations</Link></li>
                        <li><Link to="/course/learn-real" className="hover:underline">Learn Real English</Link></li>
                        <li><Link to="/course/vip" className="hover:underline">VIP Global Leadership Program</Link></li>
                    </ul>
                </div>

                {/* Column 3 */}
                <div>
                    <h4 className="text-lg font-semibold mb-4">Hỗ trợ</h4>
                    <ul className="space-y-2 text-sm text-blue-100">
                        <li><Link to="/method" className="hover:underline">Phương pháp</Link></li>
                        <li><Link to="/guide" className="hover:underline">Hướng dẫn</Link></li>
                        <li><Link to="/pricing" className="hover:underline">Bảng giá</Link></li>
                        <li><Link to="/contact" className="hover:underline">Liên hệ</Link></li>
                    </ul>
                </div>

                {/* Column 4 */}
                <div>
                    <h4 className="text-lg font-semibold mb-3">Liên hệ</h4>
                    <p className="text-sm text-blue-100">Email: effortlessenglishcontact@gmail.com</p>
                    <p className="text-sm text-blue-100 mt-2">Hotline: +84 829 100 363</p>

                    <p className="text-sm font-semibold mt-4">Kết nối với chúng tôi</p>
                    <div className="flex items-center gap-3 mt-3">
                        <a href="#" className="w-8 h-8 rounded-full bg-white flex items-center justify-center"><span className="text-blue-600 font-bold">Z</span></a>
                        <a href="#" className="w-8 h-8 rounded-full bg-white flex items-center justify-center"><span className="text-pink-500 font-bold">M</span></a>
                        <a href="#" className="w-8 h-8 rounded-full bg-white flex items-center justify-center"><span className="text-blue-400 font-bold">T</span></a>
                    </div>
                </div>
            </div>

            <div className="border-t border-[#123e48]">
                <div className="max-w-screen-xl mx-auto px-6 py-6 text-center text-blue-200">© {new Date().getFullYear()} EZ English. All rights reserved.</div>
            </div>

            {/* Back to top button */}
            <a href="#top" className="fixed right-6 bottom-6 md:bottom-8 z-40 w-12 h-12 rounded-full bg-blue-500 text-white flex items-center justify-center shadow-lg hover:bg-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor"><path d="M3.3 10.3a1 1 0 011.4 0L10 15.59l5.3-5.3a1 1 0 011.4 1.42l-6 6a1 1 0 01-1.4 0l-6-6a1 1 0 010-1.42z"/></svg>
            </a>
        </footer>
    );
}
